<template>
    <div>
        <div id="results" class="d-none" style="z-index: 2000">
            <h4>Results</h4>
        </div>

        <!-- Modal -->
        <div
            class="modal fade"
            tabindex="-1"
            ref="diceBoxModal"
            data-bs-backdrop="static"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div
                    class="modal-content bg-dark text-light rounded-3 shadow-lg dice-modal-content"
                >
                    <!-- Header -->
                    <div class="modal-header border-secondary text-center">
                        <h4 class="modal-title text-center">
                            Rolling for
                            <img :src="getIconSrc()" class="headerIcon" />
                        </h4>
                        <button
                            type="button"
                            class="btn-close"
                            aria-label="Close"
                            @click="hideModal"
                        ></button>
                    </div>

                    <!-- Body -->
                    <div
                        class="modal-body d-flex flex-column p-2"
                        id="dice-box-container"
                    >
                        <!-- Skill/Talent Inputs -->
                        <div class="d-flex gap-3 justify-content-center mb-3">
                            <div class="text-center">
                                <label class="form-label mb-1">Skill</label>
                                <div class="input-group" style="width: 120px">
                                    <button
                                        class="btn btn-secondary"
                                        type="button"
                                        @click="decrement('skill')"
                                    >
                                        -
                                    </button>
                                    <input
                                        type="number"
                                        class="form-control text-center no-spin"
                                        :value="localSkill"
                                        @input="
                                            localSkill = Number(
                                                $event.target.value
                                            )
                                        "
                                        min="0"
                                    />
                                    <button
                                        class="btn btn-secondary"
                                        type="button"
                                        @click="increment('skill')"
                                    >
                                        +
                                    </button>
                                </div>
                            </div>

                            <div class="text-center">
                                <label class="form-label mb-1">Talent</label>
                                <div class="input-group" style="width: 120px">
                                    <button
                                        class="btn btn-secondary"
                                        type="button"
                                        @click="decrement('talent')"
                                    >
                                        -
                                    </button>
                                    <input
                                        type="number"
                                        class="form-control text-center no-spin"
                                        :value="localTalent"
                                        @input="
                                            localTalent = Number(
                                                $event.target.value
                                            )
                                        "
                                        min="0"
                                    />
                                    <button
                                        class="btn btn-secondary"
                                        type="button"
                                        @click="increment('talent')"
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click="hideModal"
                        >
                            <font-awesome-icon icon="multiply" class="me-1" />
                            Close
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="rollTheDice"
                        >
                            <font-awesome-icon icon="dice" class="me-1" /> Roll
                            Dice
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import DiceBox from "@3d-dice/dice-box/dist/dice-box.es.js";
import preloadWasm from "../utils/preloadWasm.js";
import { useRosterStore } from "../stores/index";

export default {
    data() {
        return {
            skill: 0,
            talent: 0,
            localSkill: 0,
            localTalent: 0,
            modalInstance: null,
            clickHandler: null,
            rollType: null,
            monsterType: null,
            monsterTypes: useRosterStore().monsterTypes,
        };
    },
    props: {
        theme: { type: Number, default: 1 },
        clickedSkillKey: { type: String, required: true },
    },
    methods: {
        getIconSrc() {
            return this.clickedSkillKey
                ? require(`@/../public/img/${this.clickedSkillKey}${this.theme}.png`)
                : require(`@/../public/img/hybrid${this.theme}.png`);
        },

        showModal(skill, talent, type = null, monsterType = null) {
            this.skill = this.localSkill = skill;
            this.talent = this.localTalent = talent;
            this.rollType = type;
            this.monsterType = monsterType;

            if (!this.modalInstance) {
                this.modalInstance = new Modal(this.$refs.diceBoxModal);
                this.$refs.diceBoxModal.addEventListener(
                    "hidden.bs.modal",
                    this.removeClickHandler
                );
            }

            this.modalInstance.show();
        },

        hideModal() {
            if (this.modalInstance) this.modalInstance.hide();
            this.removeClickHandler();
        },

        increment(type) {
            if (type === "skill") this.localSkill++;
            if (type === "talent") this.localTalent++;
        },
        decrement(type) {
            if (type === "skill" && this.localSkill > 0) this.localSkill--;
            if (type === "talent" && this.localTalent > 0) this.localTalent--;
        },

        addClickHandler(diceBox, resultsDiv) {
            this.clickHandler = () => {
                const canvas =
                    document.getElementById(
                        "dice-box-container"
                    ).firstElementChild;
                if (
                    canvas &&
                    window.getComputedStyle(canvas).display !== "none"
                ) {
                    diceBox.hide().clear();
                    resultsDiv.classList.add("d-none");
                }
            };
            document.addEventListener("mousedown", this.clickHandler);
        },

        removeClickHandler() {
            if (this.clickHandler) {
                document.removeEventListener("mousedown", this.clickHandler);
                this.clickHandler = null;
            }
        },

        async rollTheDice() {
            const diceTypes = [];
            if (this.localSkill > 0) diceTypes.push(this.localSkill + "d6");
            if (this.localTalent > 0) diceTypes.push(this.localTalent + "d8");

            const diceTheme = this.theme === 2 ? "shiverDice2" : "shiverDice1";
            const wasmBinary = await preloadWasm(
                "/assets/DiceBox/ammo/ammo.wasm.wasm"
            );

            const diceBox = new DiceBox("#dice-box-container", {
                assetPath: "/assets/DiceBox/",
                theme: diceTheme,
                scale: 6,
                backgroundColor: "#ffcc00",
                wasmBinary,
            });

            const resultsDiv = document.getElementById("results");

            await diceBox.init();
            this.addClickHandler(diceBox, resultsDiv);
            diceBox.roll(diceTypes);

            diceBox.onRollComplete = (rollResult) => {
                this.displayDiceResults(rollResult, resultsDiv);
            };
        },

        displayDiceResults(rollResult, resultsDiv) {
            const d6Skills = [
                "grit",
                "wit",
                "smarts",
                "heart",
                "luck",
                "strange",
            ];
            const d8Talents = [
                "strange-double",
                "strange-single",
                "strange-single",
                "talent-single",
                "talent-single",
                "talent-single",
                "talent-double",
                "talent-double",
            ];

            let d6Array = [];
            let d8Array = [];
            rollResult.forEach((result) => {
                if (result.sides === 6) {
                    result.rolls.forEach((roll) => {
                        d6Array.push(d6Skills[roll.value - 1]);
                    });
                } else if (result.sides === 8) {
                    result.rolls.forEach((roll) => {
                        d8Array.push(d8Talents[roll.value - 1]);
                    });
                }
            });

            resultsDiv.innerHTML = "<h4>Results</h4>";

            d6Array.forEach((skill) => {
                const img = document.createElement("img");
                img.src = require(`@/../public/img/${skill}${this.theme}.png`);
                img.style.maxWidth = "4rem";
                img.style.margin = "0.5rem";
                img.style.backgroundColor = "black";
                img.style.display = "inline-block";
                img.style.padding = "0.5rem";
                resultsDiv.appendChild(img);
            });

            d8Array.forEach((talent) => {
                const img = document.createElement("img");
                img.src = require(`@/../public/img/${talent}.png`);
                img.style.maxWidth = "4rem";
                img.style.margin = "0.5rem";
                img.style.backgroundColor = "white";
                img.style.display = "inline-block";
                img.style.padding = "0.5rem";
                resultsDiv.appendChild(img);
            });

            if (this.rollType === "reaction") {
                // Allowed skills depend on clickedSkillKey
                const skillOrder = [
                    "grit",
                    "wit",
                    "smarts",
                    "heart",
                    "luck",
                    "strange",
                ];
                const statIndex = skillOrder.indexOf(this.clickedSkillKey);
                const allowedSkills = skillOrder.slice(0, statIndex + 1);

                const table =
                    this.monsterTypes[this.monsterType] || null;

                console.log(this.monsterTypes, this.monsterType, table);

                let effectText = "";
                if (table) {
                    if (d6Array.length > 0) {
                        const firstSkill = d6Array[0];
                        if (allowedSkills.includes(firstSkill)) {
                            effectText += table[firstSkill]
                                ? `<p>${table[firstSkill]}</p>`
                                : "<p>No effect.</p>";
                        } else {
                            effectText += "<p>No effect.</p>";
                        }
                    }
                }

                if (effectText) {
                    const hr = document.createElement("hr");
                    resultsDiv.appendChild(hr);
                    const effectHeader = document.createElement("h5");
                    effectHeader.innerText = "Special Effects";
                    resultsDiv.appendChild(effectHeader);
                    const effectDiv = document.createElement("div");
                    effectDiv.innerHTML = effectText;
                    resultsDiv.appendChild(effectDiv);
                }
            }

            resultsDiv.classList.remove("d-none");
        },
    },

    mounted() {
        if (this.$refs.diceBoxModal)
            this.modalInstance = new Modal(this.$refs.diceBoxModal);
    },

    beforeDestroy() {
        this.removeClickHandler();
    },
};
</script>

<style scoped>
#dice-box-container {
    width: 100%;
    height: 400px;
    position: relative;
    background: #2e2e2e;
    border: 2px solid #444;
    border-radius: 10px;
    overflow: hidden;
}
#dice-box-container canvas {
    width: 100% !important;
    height: 100% !important;
    display: block !important;
}
.headerIcon {
    max-width: 2rem;
    margin-right: 0.5rem;
    vertical-align: middle;
}
.modal-dialog {
    width: 90vw;
    height: 90vh;
    margin: auto;
    max-width: none;
    max-height: none;
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.modal-body {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
}
#results {
    text-align: center;
    overflow-y: auto;
    border: 1px solid #555;
    padding: 1rem 2rem;
    border-radius: 5px;
    background-color: #5b5a5a;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 38px 25px 11px 5px rgba(16, 16, 16, 0.7);
}
input.no-spin::-webkit-outer-spin-button,
input.no-spin::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input.no-spin[type="number"] {
    -moz-appearance: textfield;
}
</style>

